/* Component Dependencies */
var roomDetailsPageSectionImageTemplate = require('templates/roomDetailsPageSectionImage.hbs');
var AriesComponent = require('libs/aries-component');
var $ = require('jquery');

AriesComponent.create({

  type: 'roomDetailsPageSectionImage',

  template: {
    'roomDetailsPageSectionImage': roomDetailsPageSectionImageTemplate
  }
});
